var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseFill = function SvgCloseFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.5 10.728 4.455-4.455 1.273 1.273-4.455 4.455 4.455 4.455-1.273 1.273-4.455-4.455-4.455 4.455-1.273-1.273 4.455-4.455-4.455-4.455 1.273-1.273z"
  })));
};
export default SvgCloseFill;